import { render, staticRenderFns } from "./BannerSlider.vue?vue&type=template&id=0a1f1be4&scoped=true&"
import script from "./BannerSlider.vue?vue&type=script&lang=js&"
export * from "./BannerSlider.vue?vue&type=script&lang=js&"
import style0 from "./BannerSlider.vue?vue&type=style&index=0&id=0a1f1be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f1be4",
  null
  
)

export default component.exports